function EmailRequired(message) {
  this.name = "EmailRequired";
  this.message = message || "";
  this.stack = new Error().stack;
}
EmailRequired.prototype = Object.create(Error.prototype);
EmailRequired.prototype.constructor = EmailRequired;

export default EmailRequired;
